
<div class="modal-signup modal-content" *ngIf="Mode=='Add'">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom">

        Specimen Collection

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">


        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2">
              <div class="row margin-top-10">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <img class="img-circle-50" src="dummy.jpg" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="PatientName">{{PatientName}}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{Gender}}/{{Age2}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PatientFormttedCode}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{Phonenumber}}</label>
                </div>
              </div>
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order No</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">GG2-L17007092</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order Date</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">17-09-2020</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Lab</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">Andrology</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>-->

            </div>
            <div class="col-md-9 padding-left-0px">
              <div class="row margin-left-0px mrgin-right-0px">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-3   padding-right-5px">
                      <label class="font-weight-normal font-size-13px margin-bottom-0px">Order Id </label>
                    </div>:
                    <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                      <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{OrderId}}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-3  text-align-right  padding-right-5px">
                      <label class="font-weight-normal font-size-13px margin-bottom-0px">Branch </label>
                    </div>:
                    <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                      <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{Branch}}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-2">
                  <label class="font-weight-normal font-size-13px margin-bottom-0px">Order Date </label>
                </div>:
                <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                  <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{OrderDate| date:'MMM-dd-yyyy'}}</h4>
                </div>
              </div>
              <div class="row margin-left-0px padding-all-5px margin-right-0px backspe">
                <div class="col-md-4 padding-right-0px padding-left-3px" *ngFor="let l of SelectedTests">
                  <input type="checkbox" class="width-23px height-16px margin-top-4px margin-left-3px display-inline" [(ngModel)]="l.IsSelected" />
                  <i class="input-helper"></i>

                  <h4 class="margin-bottom-0px position-absoulte margin-top-5px font-size-12px color-Assign font-weight-bold white-space-pre display-inline">
                    {{l.TestName}}
                  </h4>
                </div>

              </div>
              <div class="row margin-left-0px margin-right-0px">

                <form class="form col-md-12" novalidate="" (ngSubmit)="onSubmit2()" #f="ngForm">
                  <div class="card margin-top-10">
                    <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-3px">
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Collection Volume</label>
                            </div>
                            <div class="col-md-4">
                              <!--<input type="text" class="form-control" placeholder="Collection Volume">-->
                              <input type="text" class="form-control" placeholder="Collection Volume"
                                     id="CurrentSaveSpecimenCollectionInfoRequest.CollectionVolume"
                                     [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.CollectionVolume"
                                     name="CurrentSaveSpecimenCollectionInfoRequest.CollectionVolume" #Endometrium="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Collection Method</label>
                            </div>
                            <div class="col-md-4">
                              <CodeTypeValue CodeType="SPCM"
                                             id="CurrentSaveSpecimenCollectionInfoRequest.TestMethod"
                                             [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.TestMethod" SelectedValue="CurrentSaveSpecimenCollectionInfoRequest.EndometriumThicknessUnits"
                                             name="CurrentSaveSpecimenCollectionInfoRequest.TestMethod">
                              </CodeTypeValue>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-left-auto">
                        <div class="col-md-12 padding-l-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-10">Collection Date</label>
                                </div>
                                <div class="col-md-4">
                                  <div class="date-form margin-top-5px form-group margin-bottom-0px">
                                    <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>

                                </div>

                              </div>

                            </div>
                          </div>





                        </div>
                      </div>
                      <div class="row margin-left-auto">
                        <div class="col-md-12 padding-l-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Time</label>
                                </div>
                                <div class="col-md-4">

                                  <input type="time" class="form-control"
                                         id="CurrentSaveSpecimenCollectionInfoRequest.CollectionTime" placeholder="Time"
                                         [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.CollectionTime"
                                         name="CurrentSaveSpecimenCollectionInfoRequest.CollectionTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                                </div>

                              </div>

                            </div>
                          </div>






                        </div>
                      </div>
                      <div class="row" *ngIf="Gender=='F'">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">DOC</label>
                            </div>
                            <div class="col-md-4">
                              <input type="text" class="form-control" placeholder="DOC"
                                     id="CurrentSaveSpecimenCollectionInfoRequest.DOC"
                                     [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.DOC"
                                     name="CurrentSaveSpecimenCollectionInfoRequest.DOC" #Endometrium1="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium1.valid && (Endometrium1.dirty || Endometrium1.touched) && Endometrium1.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium1.valid && Endometrium1.errors.pattern)">(only numbers are allowed)</small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row" *ngIf="Gender=='F'">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Gestation Age</label>
                            </div>

                            <div class="col-md-2">

                              <input type="text" class="form-control" placeholder="Age"
                                     id="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1"
                                     [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1"
                                     name="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1" #Age="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age.valid && (Age.dirty || Age.touched) && Age.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age.valid && Age.errors.pattern)">(only numbers are allowed)</small>


                            </div>
                            <div class="col-md-2 padding-right-0px">

                              <CodeTypeValue CodeType="DURTN"
                                             id="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1Units"
                                             [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1Units" SelectedValue="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1Units"
                                             name="CurrentSaveSpecimenCollectionInfoRequest.GestationAge1Units">
                              </CodeTypeValue>

                            </div>

                            <div class="col-md-2">

                              <input type="text" class="form-control" placeholder="Age2"
                                     id="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2"
                                     [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2"
                                     name="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2" #Age2="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age2.valid && (Age2.dirty || Age2.touched) && Age2.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age2.valid && Age2.errors.pattern)">(only numbers are allowed)</small>


                            </div>
                            <div class="col-md-2 padding-right-0px">
                              <CodeTypeValue CodeType="DURTN"
                                             id="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2Units"
                                             [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2Units" SelectedValue="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2Units"
                                             name="CurrentSaveSpecimenCollectionInfoRequest.GestationAge2Units">
                              </CodeTypeValue>


                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-5px">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Comments</label>
                            </div>
                            <div class="col-md-4">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                        name="CurrentSaveSpecimenCollectionInfoRequest.Comments"
                                        [(ngModel)]="CurrentSaveSpecimenCollectionInfoRequest.Comments" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                            </div>

                          </div>

                        </div>
                      </div>

                    </div>
                    <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                      <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto" [disabled]="Endometrium.errors?.required ">Save</button>
                      <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                    </div>
                  </div>
                </form>


              </div>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="Mode=='Edit'">

  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-0px border-bottom">

        Specimen Collection

        <button type="button" class="close" data-dismiss="modal"
                (click)="activeModal.dismiss('Cross click')"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-left-0px padding-top-5px">


        <div class="modal-body padding-top-0px  padding-right-0px padding-bottom-0px">

          <div class="row">
            <div class="col-md-3 padding-right-0px bk-color-light2">
              <div class="row margin-top-10">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <img class="img-circle-50" src="dummy.jpg" onError="this.src='dummy.jpg';">
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px">
                  <label class="margin-bottom-0px font-size-16px color-Assign" *ngIf="PatientName">{{PatientName}}</label>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{Gender}}/{{Age2}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{PatientFormttedCode}}</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12  text-align-center padding-left-0px line-height-17px">
                  <label class="margin-bottom-0px">{{Phonenumber}}</label>
                </div>
              </div>
              <!--<div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12 padding-right-4px padding-left-0px">
                  <div class="card card-background-transparent border-all-1px border-radius-5px">
                    <div class="card-body padding-all-0px margin-left-0px">
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order No</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">GG2-L17007092</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Order Date</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">17-09-2020</label>
                        </div>
                      </div>
                      <div class="row margin-left-0px">
                        <div class="col-md-5 text-align-right padding-left-0px">
                          <label class="margin-bottom-0px font-size-12px">Lab</label>
                        </div>:
                        <div class="col-md-6 padding-right-0px">
                          <label class=" font-size-12px margin-bottom-0px margin-top-3px">Andrology</label>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>-->

            </div>
            <div class="col-md-9 padding-left-0px">
              <div class="row margin-left-0px mrgin-right-0px">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-3   padding-right-5px">
                      <label class="font-weight-normal font-size-13px margin-bottom-0px">Order Id </label>
                    </div>:
                    <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                      <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{OrderId}}</h4>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-3  text-align-right  padding-right-5px">
                      <label class="font-weight-normal font-size-13px margin-bottom-0px">Branch </label>
                    </div>:
                    <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                      <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{Branch}}</h4>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-2">
                  <label class="font-weight-normal font-size-13px margin-bottom-0px">Order Date </label>
                </div>:
                <div class="col-md-5 padding-right-0px padding-left-10px margin-top-5px">
                  <h4 class="font-weight-bold font-size-13px margin-bottom-0px color-Assign">{{OrderDate| date:'MMM-dd-yyyy'}}</h4>
                </div>
              </div>
              <div class="row margin-left-0px padding-all-5px margin-right-0px backspe">
                <div class="col-md-6 padding-right-0px padding-left-3px">


                  <h4 class="margin-bottom-0px  margin-top-5px font-size-12px color-Assign font-weight-bold white-space-pre display-inline">
                    {{Tests}}
                  </h4>
                </div>

              </div>
              <div class="row margin-left-0px margin-right-0px">

                <form class="form col-md-12" novalidate="" (ngSubmit)="onSubmitEdit()" #f="ngForm">
                  <div class="card margin-top-10">
                    <div class="card-body margin-left-zero padding-left-0px padding-right-0px padding-top-3px">
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Collection Volume</label>
                            </div>
                            <div class="col-md-4">
                              <!--<input type="text" class="form-control" placeholder="Collection Volume">-->
                              <input type="text" class="form-control" placeholder="Collection Volume"
                                     id="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionVolume"
                                     [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionVolume"
                                     name="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionVolume" #Endometrium="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Collection Method</label>
                            </div>
                            <div class="col-md-4">
                              <CodeTypeValue CodeType="SPCM"
                                             id="CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod" PassType="Long"
                                             [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod" SelectedValue="{{CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod}}"
                                             name="CurrentEditSaveSpecimenCollectionInfoRequest.TestMethod">
                              </CodeTypeValue>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row margin-left-auto">
                        <div class="col-md-12 padding-l-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-10">Collection Date</label>
                                </div>
                                <div class="col-md-4">
                                  <div class="date-form margin-top-5px form-group margin-bottom-0px">
                                    <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                                    <a (click)="d.toggle()" class="nav-link-hand">
                                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                    </a>

                                  </div>

                                </div>

                              </div>

                            </div>
                          </div>





                        </div>
                      </div>
                      <div class="row margin-left-auto">
                        <div class="col-md-12 padding-l-0px">
                          <div class="row">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                              <div class="row">
                                <div class="col-md-3 text-align-right padding-left-0px">
                                  <label for="firstName" class="margin-bottom-0px margin-top-5px">Time</label>
                                </div>
                                <div class="col-md-4">

                                  <input type="time" class="form-control"
                                         id="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionTime" placeholder="Time"
                                         [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionTime"
                                         name="CurrentEditSaveSpecimenCollectionInfoRequest.CollectionTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />

                                </div>

                              </div>

                            </div>
                          </div>






                        </div>
                      </div>
                      <div class="row" *ngIf="Gender=='F'">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">DOC</label>
                            </div>
                            <div class="col-md-4">
                              <input type="text" class="form-control" placeholder="DOC"
                                     id="CurrentEditSaveSpecimenCollectionInfoRequest.DOC"
                                     [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.DOC"
                                     name="CurrentEditSaveSpecimenCollectionInfoRequest.DOC" #Endometrium1="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium1.valid && (Endometrium1.dirty || Endometrium1.touched) && Endometrium1.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Endometrium1.valid && Endometrium1.errors.pattern)">(only numbers are allowed)</small>

                            </div>

                          </div>

                        </div>
                      </div>
                      <div class="row" *ngIf="Gender=='F'">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Gestation Age</label>
                            </div>

                            <div class="col-md-2">

                              <input type="text" class="form-control" placeholder="Age"
                                     id="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1"
                                     [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1"
                                     name="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1" #Age="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age.valid && (Age.dirty || Age.touched) && Age.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age.valid && Age.errors.pattern)">(only numbers are allowed)</small>


                            </div>
                            <div class="col-md-2 padding-right-0px">

                              <CodeTypeValue CodeType="DURTN"
                                             id="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units"
                                             [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units" SelectedValue="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units"
                                             name="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge1Units">
                              </CodeTypeValue>

                            </div>

                            <div class="col-md-2">

                              <input type="text" class="form-control" placeholder="Age2"
                                     id="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2"
                                     [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2"
                                     name="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2" #Age2="ngModel"
                                     maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age2.valid && (Age2.dirty || Age2.touched) && Age2.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Age2.valid && Age2.errors.pattern)">(only numbers are allowed)</small>


                            </div>
                            <div class="col-md-2 padding-right-0px">
                              <CodeTypeValue CodeType="DURTN"
                                             id="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units"
                                             [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units" SelectedValue="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units"
                                             name="CurrentEditSaveSpecimenCollectionInfoRequest.GestationAge2Units">
                              </CodeTypeValue>


                            </div>
                          </div>

                        </div>
                      </div>
                      <div class="row margin-top-5px">
                        <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                          <div class="row">
                            <div class="col-md-3 text-align-right padding-left-0px">
                              <label for="firstName" class="margin-bottom-0px margin-top-5px">Comments</label>
                            </div>
                            <div class="col-md-4">
                              <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Comments"
                                        name="CurrentEditSaveSpecimenCollectionInfoRequest.Comments"
                                        [(ngModel)]="CurrentEditSaveSpecimenCollectionInfoRequest.Comments" required minlength="1" maxlength="100"
                                        #addconcerns_text="ngModel"></textarea>
                              <small class="form-text text-danger"
                                     *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>


                            </div>

                          </div>

                        </div>
                      </div>

                    </div>
                    <div class="card-footer text-align-center padding-top-10 padding-bottom-10px">
                      <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto" [disabled]="Endometrium.errors?.required ">Save</button>
                      <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto float-right margin-right-10px" (click)="activeModal.close('Close click')">Close</button>

                    </div>
                  </div>
                </form>


              </div>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>
